import { env } from '@config/env';
import type { GuardAuthMode } from '@config/env/types';
import { useAuthStore } from '@shared/stores/authStore';

/** Resolved auth mode after applying `auto` and build-time key. */
export function effectiveGuardAuthMode(): GuardAuthMode {
  if (env.guardAuthMode === 'auto') {
    return env.guardApiKey?.trim() ? 'api_key' : 'user';
  }
  return env.guardAuthMode;
}

export function requiresUserLogin(): boolean {
  return effectiveGuardAuthMode() === 'user';
}

export function canUseApiKeyFromEnv(): boolean {
  return effectiveGuardAuthMode() === 'api_key' && !!env.guardApiKey?.trim();
}

/** Apply build-time API key + tenant from env (kiosk builds). */
export async function applyEnvApiKeyIfConfigured(): Promise<boolean> {
  const key = env.guardApiKey?.trim();
  const tenantId = env.guardTenantId?.trim();
  if (!key || !tenantId) return false;
  await useAuthStore.getState().setApiKeyAuth(key, tenantId);
  return true;
}

export function isGuardSessionReady(): boolean {
  return useAuthStore.getState().isAuthenticated();
}
